import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { JarwisService } from '../../../Services/jarwis.service';
import { TokenService } from '../../../Services/token.service';


@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrls: ['./persona.component.scss']
})
export class PersonaComponent implements OnInit {

  constructor(
    private Jarwis :JarwisService,
    private Token:TokenService,
    private router :Router
  ) {}

  public form ={
    id_root: 0,  
    tipo_usuario:2,
    principalOSecundario:'principal', 
    nombre_completo:null,
    telefono: null,       
    email: null,   
    password: null  
  }
  
  public error = [];
  panelError:boolean=false;
  onSubmit(){
    this.Jarwis.signup(this.form).subscribe(
      data =>this.handleResponse(data),
      error =>this.handleError(error)
    )
  }

  handleResponse(data){    
    this.Token.handle(data.access_token,this.typeLocalStorage(data.tipo_usuario),this.convenioLocalStorage(data.convenio));
    this.router.navigate(['/profile/pedido']);

    //localStorage.setItem("page","region");
    //this.router.navigate(['/escoge-tu-region']);
  }

  typeLocalStorage(data){
    if( data == 1){
      return "administrador";
    }else if( data ==  2 ){
      return "persona";
    }else if(data == 3){
      return "empresa";
    }else if(data == 4){
      return "motorizado";
    }      
  }
  convenioLocalStorage(data){
    if(data==0){
      return "desactivado";
    }else if(data==1){
      return "activado";
    }
  }

  
  handleError(error){
    this.error = error.error.errors;
    this.panelError=true;
  }
 

  visibility(visibility,visibilityIcon){ 
    const mostrar_password = document.querySelector(visibility);
    const type = mostrar_password.getAttribute("type");
    const visibility_icon = <HTMLElement>document.querySelector(visibilityIcon);
    if(type == "password"){
      mostrar_password.setAttribute("type","text");
      visibility_icon.classList.add('visibility_icon_active');
    }else{
      mostrar_password.setAttribute("type","password");
      visibility_icon.classList.remove('visibility_icon_active');
    }
  }

   ngOnInit() {
  }


}
